import { Component } from '@angular/core';
import { TrisPrice } from '@app/@shared/models/tris.model';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-tris-combos',
  templateUrl: './tris-combos.component.html',
  styleUrl: './tris-combos.component.scss',
})
export class TrisCombosComponent {
  combos: TrisPrice[] = [];
  selected!: TrisPrice;
  supercombinaciones = false;

  constructor(private modalCtrl: ModalController) {}

  changeCombo(combo: TrisPrice) {
    this.modalCtrl.dismiss(combo, 'save');
  }

  close() {
    this.modalCtrl.dismiss();
  }
}
